import type { TierId } from '@/types/member/memberTypes'
import type { TierStatusConfig } from '~/types/ui/uiTypes'
import { STATUS_LABELS } from '@/constants/ui'
import { MEMBERSHIP_ENDED } from '@/content/membership'

export type { TierStatusConfig }

export function getMembershipStatusConfig(options: {
  isDeactivated?: boolean
  hasEnded?: boolean
  hasIssues?: boolean
  isOnboarding?: boolean
}): TierStatusConfig {
  const { isDeactivated, hasEnded, hasIssues, isOnboarding } = options

  if (hasEnded) {
    return {
      key: 'ended',
      text: MEMBERSHIP_ENDED.statusLabel,
      tone: 'neutral',
    }
  }

  // The banner and the Reactivate flow call a lapsed membership suspended; the badge agrees.
  if (isDeactivated) {
    return {
      key: 'suspended',
      text: STATUS_LABELS.SUSPENDED,
      tone: 'danger',
    }
  }

  if (hasIssues) {
    return {
      key: 'action-required',
      text: STATUS_LABELS.ACTION_REQUIRED,
      tone: 'warn',
    }
  }

  if (isOnboarding) {
    return {
      key: 'onboarding',
      text: STATUS_LABELS.ONBOARDING,
      tone: 'info',
    }
  }

  return {
    key: 'active',
    text: STATUS_LABELS.ACTIVE,
    tone: 'accent',
  }
}

export function normalizeTierId(tier?: string): TierId {
  const normalized = tier?.toLowerCase()
  if (normalized === 'gold' || normalized === 'silver' || normalized === 'bronze' || normalized === 'trial') {
    return normalized
  }
  return 'bronze'
}
